import { h } from 'preact';
import { useState } from 'preact/hooks';
import { ConfirmDialog } from '../ConfirmDialog';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

function ConfirmDialogShowcaseWrapper() {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Button variant="danger" onClick={() => setOpen(true)}>Excluir Item</Button>
      <ConfirmDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={() => setOpen(false)}
        title="Confirmar exclusão"
        message="Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita."
        variant="danger"
        confirmLabel="Excluir"
      />
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'ConfirmDialog',
  category: '🪟 Modais & Overlay',
  description: 'Diálogo de confirmação com variante danger e mensagem customizável',
  usedIn: ['AgentesPage', 'Integrations'],
  example: () => <ConfirmDialogShowcaseWrapper />,
};
